import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import assessmentCancelled from "../../../../../../public/images/access-screens/assessmentCancelled.svg";
import Button from "@assessment/components/atoms/button";

const AssessmentCancelled = ({ title }: { title?: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-12 py-8">
      <div className="w-full grid md:grid-cols-2 gap-20 lg:gap-28 items-center">
        <div className="flex justify-center">
          <img
            src={assessmentCancelled}
            alt="assessment cancelled"
            className="w-full max-w-2xl select-none"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>

        <div className="flex flex-col justify-center items-start w-full pr-6 lg:pr-12">
          <h1 className="w-full text-2xl md:text-3xl lg:text-4xl font-semibold text-red-500 leading-snug mb-4">
            {t("assessment.access.cancelledTitle", { title: title || "" })}
          </h1>

          <p className="w-full text-gray-500 md:text-lg lg:text-xl leading-relaxed font-medium tracking-wide mb-10 text-base">
            {t("assessment.access.cancelledDescription")}
          </p>

          <div className="flex flex-wrap gap-5">
            <Button
              variant="contained"
              label={t("assessment.access.goToHome")}
              onClick={() => navigate("/")}
              testId="errorHomeBtn"
            />

            <Button
              variant="outlined"
              label={t("assessment.access.refreshPage")}
              onClick={() => window.location.reload()}
              testId="errorRefreshBtn"
              className="border border-gray-300 text-gray-600 px-6 py-2 rounded-md hover:bg-gray-100"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentCancelled;
